import {
  getLabelList,
  upAndDownLabel,
  labelDelete,
  addAndModifyLabel,
  modifyLabelAudit,
  getAllGroupList,
  getGroupList,
  addGroup,
  modifyGroup,
  groupDelete,
  groupSwitch,
  groupMove,
  labelMove
} from '../../services/webSiteSetUp/labelSetting';
import { GetQueryString } from '../../utils/utils';

const initState = {
  dataSource: [],
  totalElements: 0,
  params: {
    appCode: Number(GetQueryString('appCode')) || 1,
    page: 1,
    pageSize: 10,
  },
  showOrderModal: false,
  modalVisible: false,
  modalTitle: '新增分组',
  formData: {},

  isGroup: true, // 是否选中的是标签分组
  allGroupList: [],
  currentTagData: {}
};

export default {
  namespace: 'labelSetting',
  state: initState,
  effects: {

    *fetchAllGroupList({ params }, { call, put }) {
      try {
        const response = yield call(getAllGroupList, params);
        yield put({
          type: 'saveState',
          payload: {
            allGroupList: response
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },

    *fetchGroupList({ params }, { call, put }) {
      try {
        const response = yield call(getGroupList, params);
        yield put({
          type: 'saveState',
          payload: { dataSource: response.content, totalElements: response.totalElements, params },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },

    *fetchLabelList({ params }, { call, put }) {
      try {
        const response = yield call(getLabelList, params);
        yield put({
          type: 'saveState',
          payload: { dataSource: response.content, totalElements: response.totalElements, params },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchUpAndDownLabel({ params }, { call }) {
      try {
        const response = yield call(upAndDownLabel, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchLabelDelete({ params }, { call }) {
      try {
        const response = yield call(labelDelete, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchGroupDelete({ params }, { call }) {
      try {
        const response = yield call(groupDelete, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchOrderSwitch({ params }, { call }) {
      try {
        const response = yield call(groupSwitch, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchGroupMove({ params, currentType }, { call }) {
      try {
        let response;
        if (currentType == 'group') {
          response = yield call(groupMove, params);
        } else {
          response = yield call(labelMove, params);
        }
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },

    *fetchAddAndModifyLabel({ params }, { call }) {
      try {
        const response = yield call(addAndModifyLabel, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchAddAndModifyGroup({ params }, { call }) {
      try {
        let response;
        if (params.id) {
          response = yield call(modifyGroup, params);
        } else {
          response = yield call(addGroup, params);
        }
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
